function messageBox (){
      if(!JSON.parse(localStorage.getItem('noticeMessage'))) return
      if(JSON.parse(localStorage.getItem('noticeMessage')).length === 0) return
      let title = JSON.parse(localStorage.getItem('noticeMessage'))[0].noticeTitle;
      let titleText,contentText,buttonText;
      let pushType = JSON.parse(localStorage.getItem('noticeMessage'))[0].pushType;
      if(title.length <= 40){
            titleText = title
      } else {
            titleText = title.substr(1,40)
      }
      let content = JSON.parse(localStorage.getItem('noticeMessage'))[0].noticeContent
      if(content.length <= 240){
            contentText = content
      } else {
            contentText = content.substr(1,40)
      }
      let button = JSON.parse(localStorage.getItem('noticeMessage'))[0].buttonText
      if(button.length <= 6){
            buttonText = button
      } else {
            buttonText = button.substr(1,6)
      }  
      let warningImg = require('./src/assets/warning.png');  
      let template = `
      
            <div id="messageBox">
             <img src=${warningImg} width='114' height='82'/>
              <h3>${titleText}</h3>
                  <p>${content}</p>
                  <button id="buttonText">${buttonText}</button>
             </div>
             <style>
                  #messageBox .delet-icon{
                        float:right;
                        cursor: pointer;
                  }
                  #messageBox{
                        padding: 16px 24px;
                        width: 296px;
                        box-sizing:border-box;
                        background: #FFFFFF;
                        box-shadow: 0px 0px 8px 4px rgba(0, 0, 0, 0.05);
                        border-radius: 8px;
                        position: absolute;
                        left:50%;
                        margin-left:-148px;
                        top:104px;
                        z-index:2021;
                  }
                  #messageBox img{
                        display:block;
                        margin:0 auto;
                  }
                  #messageBox h3{
                        font-size: 20px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #202124;
                        line-height: 24px;
                        text-align:center;
                  }
                  #messageBox p{
                        font-size: 16px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #202124;
                        line-height: 28px;
                        text-align:center;
                  }
                  #messageBox button{
                        color:#fff;
                        height: 32px;
                        border:none;
                        padding:0px 23px;
                        background: linear-gradient(136deg, #227FFF 0%, #316FFF 100%);
                        border-radius: 22px;
                        padding:0px 27px;
                        cursor: pointer;
                        margin:0px auto;
                        display:block;
                  }
             </style>          
             `
             let imgsrc = require('./src/assets/systembc.png');
             console.log('imgsrc---->',imgsrc)
             function getClientHeight()
             {
               var clientHeight=0;
               if(document.body.clientHeight&&document.documentElement.clientHeight)
               {
               var clientHeight = (document.body.clientHeight<document.documentElement.clientHeight)?document.body.clientHeight:document.documentElement.clientHeight;
               }
               else
               {
               var clientHeight = (document.body.clientHeight>document.documentElement.clientHeight)?document.body.clientHeight:document.documentElement.clientHeight;
               }
               return clientHeight;
             }
             let templateCover = 
             `
                   <div id="message-cover">
                         <h3>${titleText}</h3>
                         <p>${contentText}</p>
                   </div>
                   <style>
                   #message-cover{
                         padding-top:80px;
                         width:100%;
                         background: #fff url(${imgsrc}) no-repeat center bottom 240px;
                         background-size: 375px auto;
                         position: fixed;
                         left:0px;
                         top:0px;
                         z-index:20211117;
                         height: calc(100vh);
                         box-sizing: border-box;
                   } 
                   #message-cover h3{
                         margin:0px;
                         margin-bottom:8px;
                         text-align:center;
                         height: 45px;
                         font-size: 32px;
                         font-family: PingFangSC-Medium, PingFang SC;
                         font-weight: 500;
                         color: #333333;
                         line-height: 45px;     
                   } 
                   #message-cover p{
                         margin:0px;
                         margin-bottom:40px;
                         text-align:center;
                         font-size: 18px;
                         font-family: PingFangSC-Regular, PingFang SC;
                         color: #08224D;
                         line-height: 28px;
                   }   
                   </style>
             `
       let tamplateType = pushType == 1 ? template : templateCover;
      document.querySelector('body').insertAdjacentHTML("beforebegin",tamplateType);
      if(pushType == 1){
            document.querySelector('#buttonText').onclick=()=>{
                  document.querySelector('#messageBox').remove();
                  sessionStorage.setItem("nomessage",false)
            } 
      }  
               
}
export default messageBox